import api from "./api";

export const GraficoService = {
  buscarVisiveisUsuario: () => api.get(`/grafico`),
  buscarDadosGraficoPorChave: (chaveGrafico, filtros) => api.get(`/grafico/chave/${chaveGrafico}`, { params: filtros })
};
